<app-social-shell active="messages">
    <div class="sm-wrap">

      @if (!activeUserId) {
        <!-- ================= INBOX ================= -->
        <div class="sm-page-header">
          <button type="button" class="sf-back-btn" (click)="back()">
            <i class="fa fa-arrow-left"></i> <span>Back</span>
          </button>
          <h1 class="sm-title">Messages</h1>
        </div>

        @if (threadsLoading) {
          <p class="sg-loading">Loading conversations…</p>
        }
        @if (threadsError && !threadsLoading) {
          <p class="sg-empty sf-error-state">
            Couldn't load your messages.
            <button type="button" class="sf-retry-btn" (click)="loadThreads()">Try again</button>
          </p>
        }
        @if (!threadsError && !threadsLoading && threads.length === 0) {
          <p class="sg-empty">
            No conversations yet. Visit someone's profile and click <strong>Message</strong> to start one.
          </p>
        }

        <div class="sm-threads">
          @for (t of threads; track t.author.id) {
            <button type="button" class="sm-thread-row" [class.is-unread]="t.unread_count > 0" (click)="openThread(t.author.id)">
              <span class="sf-avatar sf-avatar-lg">
                @if (t.author.avatar) {
                  <img [src]="avatarUrl(t.author.avatar)" alt="" (error)="t.author.avatar = null" />
                } @else {
                  {{ initials(t.author.name) }}
                }
              </span>
              <span class="sm-thread-text">
                <span class="sm-thread-name">{{ t.author.name }}</span>
                <span class="sm-thread-preview">
                  @if (t.last_message_is_mine) {
                    <span class="sm-thread-you">You:</span>
                  }
                  {{ t.last_message }}
                </span>
              </span>
              <span class="sm-thread-meta">
                <span class="sm-thread-time">{{ timeAgo(t.last_message_at) }}</span>
                @if (t.unread_count > 0) {
                  <span class="sf-notif-badge">{{ t.unread_count }}</span>
                }
              </span>
            </button>
          }
        </div>

        @if (hasMoreThreads) {
          <button type="button" class="sf-load-more" [disabled]="loadingMoreThreads" (click)="loadMoreThreads()">
            {{ loadingMoreThreads ? 'Loading…' : 'Load more' }}
          </button>
        }
      } @else {
        <!-- ================= A CONVERSATION ================= -->
        @if (partnerNotFound) {
          <div class="sm-page-header">
            <button type="button" class="sf-back-btn" (click)="back()">
              <i class="fa fa-arrow-left"></i> <span>Back</span>
            </button>
          </div>
          <div class="sg-notfound">
            <h2>Person not found</h2>
          </div>
        } @else {
          <div class="sm-thread-header">
            <button type="button" class="sf-back-btn sm-thread-back" (click)="back()">
              <i class="fa fa-arrow-left"></i> <span>Back</span>
            </button>
            <span class="sf-avatar sf-avatar-lg" role="link" tabindex="0" (click)="openPartnerProfile()" (keyup.enter)="openPartnerProfile()">
              @if (partner?.author?.avatar) {
                <img [src]="avatarUrl(partner!.author.avatar)" alt="" (error)="partner!.author.avatar = null" />
              } @else {
                {{ initials(partner?.author?.name || '') }}
              }
            </span>
            <span class="sm-thread-header-name" role="link" tabindex="0" (click)="openPartnerProfile()" (keyup.enter)="openPartnerProfile()">
              {{ partnerLoading ? 'Loading…' : (partner?.author?.name || '') }}
            </span>
          </div>

          @if (threadError) {
            <p class="sf-attach-error sm-thread-error">{{ threadError }}</p>
          } @else {
            <div class="sm-messages">
              @if (messagesLoading) {
                <p class="sg-loading">Loading messages…</p>
              }
              @if (hasOlderMessages) {
                <button type="button" class="sf-load-more sm-load-older" [disabled]="loadingOlderMessages" (click)="loadOlderMessages()">
                  {{ loadingOlderMessages ? 'Loading…' : 'Load older' }}
                </button>
              }
              @for (m of messages; track m.id) {
                <div class="sm-message" [class.is-mine]="m.is_mine" [class.is-pending]="m.pending">
                  <span class="sm-message-bubble">{{ m.content }}</span>
                  <span class="sm-message-time">{{ timeAgo(m.created_at) }}</span>
                </div>
              }
              @if (!messagesLoading && messages.length === 0) {
                <p class="sg-empty">No messages yet. Say hello!</p>
              }
            </div>

            <div class="sm-compose">
              <input
                #composerBox
                type="text"
                placeholder="Write a message…"
                aria-label="Write a message"
                maxlength="2000"
                [(ngModel)]="draft"
                (keyup.enter)="send()" />
              <app-social-emoji-picker [target]="composerBox"></app-social-emoji-picker>
              <button type="button" [disabled]="sending || !draft.trim()" (click)="send()">
                {{ sending ? 'Sending…' : 'Send' }}
              </button>
            </div>
            @if (sendError) {
              <p class="sf-attach-error">{{ sendError }}</p>
            }
          }
        }
      }

    </div>
</app-social-shell>
